import React, { useCallback } from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import FieldContainer from '../../field-container/FieldContainer';
import Input from '../../form/Input';

const Note = ({ className, disabled, value, onChange }) => {
  const handleNoteChange = useCallback(
    e => {
      onChange('note', e.target.value);
    },
    [onChange]
  );

  const { TextArea } = Input;

  return (
    <FieldContainer className={cn('note', className)}>
      <div className="label-spinner">
        <div className="label">Project Notes</div>
        <div className={cn('spinner', { spinning: false })}>
          <span className="fas fa-sync fa-spin" />
        </div>
      </div>
      <TextArea rows={4} value={value || ''} onChange={handleNoteChange} disabled={disabled} data-testid="note_input" />
    </FieldContainer>
  );
};

export default styled(Note)``;
